class TimelineHistory {
    constructor(element) {
        console.log('TimelineHistory.constructor 12');

        this.element = element;
        this.items = this.element.getElementsByClassName('timeline-history-item');

        /*
        for (let i = Math.round(this.items.length / 2); i < this.items.length; i++) {
            console.log(i, this.items[i]);
            this.items[i].classList.add('bottomUp');
        }*/

        this.onClose = this.onClose.bind(this);
        this.onOpen = this.onOpen.bind(this);
        for (let i = 0; i < this.items.length; i++) {
            this.items[i].getElementsByClassName('head')[0].addEventListener('click', this.onOpen);
        }
        for (let i = 0; i < this.items.length; i++) {
            this.items[i].getElementsByClassName('panel')[0].getElementsByClassName('button-close')[0].addEventListener('click', this.onClose);
        }

        this.windowWidth;
        this.windowHeight;
        this.onResize = this.onResize.bind(this);
        window.addEventListener('resize', this.onResize);
    }

    destroy() {
        console.log('TimelineHistory.destroy');
        window.removeEventListener('resize', this.resizeHandler);

        for (let i = 0; i < this.items.length; i++) {
            this.items[i].getElementsByClassName('head')[0].removeEventListener('click', this.onOpen);
        }
        for (let i = 0; i < this.items.length; i++) {
            this.items[i].getElementsByClassName('panel')[0].getElementsByClassName('button-close')[0].removeEventListener('click', this.onClose);
        }
    }

    close() {
        for (let i = 0; i < this.items.length; i++) {
            this.items[i].classList.remove('selected');
        }
    }

    onOpen(event) {
        console.log('TimelineHistory.onOpen', event, event.currentTarget.parentNode);
        event.stopPropagation();
        //this.close();

        event.currentTarget.parentNode.classList.toggle('selected');
    }

    onClose(event) {
        console.log('TimelineHistory.onClose', event);
        event.stopPropagation();
        //this.close();
        event.currentTarget.parentNode.parentNode.classList.toggle('selected');
    }

    onResize(event) {
        console.log('TimelineHistory.onResize', event, window.innerWidth, window.innerHeight);
        this.windowWidth = window.innerWidth;
        this.windowHeight = window.innerHeight;
    }
}

TimelineHistory.elementClassName = 'timeline-history';
TimelineHistory.instances = [];
TimelineHistory.init = function () {
    console.log('TimelineHistory.init');
    var elements = document.getElementsByClassName(TimelineHistory.elementClassName);
    for (const element of Array.from(elements)) {
        TimelineHistory.instances.push(new TimelineHistory(element));
    }
    console.log('TimelineHistory.instances.length', TimelineHistory.instances.length);
};

TimelineHistory.onDispose = function () {
    console.log('TimelineHistory.onDispose');
    while (TimelineHistory.instances.length) {
        console.log('TimelineHistory.instances.length', TimelineHistory.instances.length);
        let instance = TimelineHistory.instances.pop();
        instance.destroy();
        instance = null;
    }
};

export default TimelineHistory;

if (module.hot) {
    module.hot.dispose(TimelineHistory.onDispose);
}
